export default class PickerTypeEnum {
    static get radio() {
        return "radio";
    }
    static get checkbox() {
        return "checkbox";
    }
}
